import "./NoMatch.css"
import React from "react"
import { Wrapper } from "../lib"
import fourOfour from "../assets/404.svg"
import fourOfourEmoji from "../assets/404-emoji.svg"
import squiggle from "../assets/squiggle.svg"

const NoMatch = ({ location, match }) => (
  <Wrapper>
    <div className="NoMatch">
      <div className="NoMatch_info">
        <img src={fourOfour} role="presentation" />
        <h1>Looks like you done got lost M8. . .</h1>
        <p>Sorry but {location.pathname} didn’t match any pages</p>
        <img src={squiggle} className="NoMatch_squiggle" role="presentation" />
      </div>
      <div className="NoMatch_img">
        <img src={fourOfourEmoji} role="presentation" />
      </div>
    </div>
  </Wrapper>
)

NoMatch.displayName = "NoMatch"

export default NoMatch



// WEBPACK FOOTER //
// ./src/app/NoMatch.js